import {DtoModel} from '../../../../common/entity/dto/dto.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {CommunicationConfigurationEmailModel} from '../../email/common/api/model/communicationConfigurationEmail.model';

export class CommunicationConfigurationModel implements DtoModel {
    emailConfiguration: CommunicationConfigurationEmailModel;
    smsContent: string;
    priority: LovValueSummary;
}
